import { Col, Form, Input, Row, Select } from 'antd';
import React from 'react';

export const FreeAddressInput = () => {
  return (
    <>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Street" name="street" width={400}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="House number" name="houseNumber">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Suffix" name="suffix">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Postal Code" name="postalCode" width={400}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="City" name="city">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Country Code" name="countryCode" initialValue="NL">
            <Select
              options={[
                { value: 'NL', label: 'Netherlands' },
                { value: 'BE', label: 'Belgium' },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
